export default __webpack_public_path__ + "static/media/jamesemmanuel.0ebc6def.png";